import { API_Handler } from "./API_Handler";
import { encryptData } from "../Utilities/EncryptData";

export const Satta_Market_API =
{
    Get_Satta_Maket: async (Request, Token) => await API_Handler.get('/sattaMatka/sattaMarket'),
    
}